import React from 'react';

import { FicheDisplay } from 'components/FicheDisplay/FicheDisplay';
import { DataFieldDisplay } from 'components/FieldDisplay/DataFieldDisplay';
import { FieldDisplay } from 'components/FieldDisplay/FieldDisplay';
import { formatJuridictionDto } from 'utils/dtoToString';

import { SingleFicheProps } from '../types';

export const FicheJudiciaire = ({
  dossier,
}: SingleFicheProps): React.ReactElement => {
  const leftSideChildren = [
    <DataFieldDisplay
      key={1}
      label={'Juridiction'}
      value={dossier.computed?.juridictionDto || null}
      formatter={formatJuridictionDto}
    />,
    <FieldDisplay
      key={2}
      label={'№ de Parquet'}
      value={dossier.body?.ficheJudiciaire?.numeroParquet || null}
    />,
    <FieldDisplay
      key={3}
      label={'№ de PV'}
      value={dossier.body?.ficheJudiciaire?.numeroPv || null}
    />,
    <FieldDisplay
      key={4}
      label={'№ IDJ'}
      value={dossier.body?.ficheJudiciaire?.numeroIDJ || null}
    />,
    <FieldDisplay
      key={5}
      label={'Valeur juridique'}
      value={dossier.body?.ficheJudiciaire?.valeurJuridique || null}
    />,
  ];

  return (
    <FicheDisplay leftSideChildren={leftSideChildren} rightSideChildren={[]} />
  );
};
